import _ from 'lodash';
import Evee from 'evee';

import EventBus from './EventBus.js';
import WebBuffer from './WebBuffer.js';

export default class WebBufferCollection {
    constructor() {
        this._enabled = true;
        this._buffers = [];
    }


    makeNewBuffer(uri) {
        var buffer = new WebBuffer();
        buffer.setSource(uri);
        this._buffers.push(buffer);
    }

    destroyBuffers(uri) {
        var r = [];
        for (let buffer of this._buffers) {
            if (buffer.getUri() == uri) {
                buffer.destroy();
            } else {
                r.push(buffer);
            }
        }
        this._buffers = r;
    }

    destroyAllBuffers() {
        for (let buffer of this._buffers) {
            buffer.destroy();
        }
        this._buffers = [];
    }

    getBuffer(uri, fullUriMatch) {
        if (!fullUriMatch) {
            uri = this._cleanUri(uri);
        }
        for (let buffer of this._buffers) {
            var bufferUri = buffer.getUri();
            if (!fullUriMatch && bufferUri) {
                bufferUri = this._cleanUri(bufferUri);
            }
            if (bufferUri && bufferUri == uri) {
                return buffer;
            }
        }
        return null;
    }

    hasReadyBuffer(uri, fullUriMatch) {
        var buffer = this.getBuffer(uri, fullUriMatch);
        return buffer && buffer.ready();
    }


    _cleanUri(uri) {
        var uriRegex = /(.*?)\?/g;
        var matches = uriRegex.exec(uri);
        return matches[1];
    }
}



// WEBPACK FOOTER //
// ./src/WebBufferCollection.js